// extracted by mini-css-extract-plugin
export default {"disableDownload":"ButtonDownload_disableDownload__TfLnA","button":"ButtonDownload_button__k-D9b","hasDisable":"ButtonDownload_hasDisable__GMNwj"};